import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_URL = process.env.REACT_APP_WHATSAPP_URL || "https://wa.me/message/YRGDSJ7JQDVUA1";
export const PHONE = process.env.REACT_APP_PHONE || "+1 623-777-8947";
export const EMAIL = process.env.REACT_APP_EMAIL || "patientcare@myglobaldentist.net";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mgd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function whatsappLink() {
  return WHATSAPP_URL;
}
